module.exports = __webpack_public_path__ + "media/images/version_merge/why_accept-68ba95cf533d87cf3f3dd0d023010a0a.svg";